export default "__VITE_ASSET__Cdyq51Sn__"